import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

import "react-image-crop/dist/ReactCrop.css";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogContent = withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function WarningModal(props) {
  const { isOpen = false, handleClose, onConfirm } = props;

  const confirm = () => {
    onConfirm();
    handleClose();
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <DialogContent dividers>
          <p>
            استاد گرامی، تعداد ساعات تدریس شما کمتر از ۵ ساعت در هفته می‌باشد.
            برای نمایش در لیست اساتید، می‌بایست حداقل ۵ ساعت زمان خالی در برنامه
            خود داشته باشید. با زدن دکمه تایید، پروفایل شما در لیست اساتید نمایش
            داده نخواهد شد.
          </p>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="outlined"
            onClick={handleClose}
            color="primary"
          >
            بازگشت
          </Button>
          <Button
            autoFocus
            variant="contained"
            onClick={confirm}
            color="primary"
          >
            تایید
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default React.memo(WarningModal);
